import React from "react";
import { useTranslation } from "react-i18next";
import { useRemoveCost } from "@planzone/view-models";
import { Modal } from "@common/modal";
import { Button } from "@common/button";
import { Props } from "./types";
import styles from "./styles.scss";

function CostRemoval({ cost, cancel }: Props) {
  const { t } = useTranslation();
  const { isRequestPending, removeCost } = useRemoveCost(cost);

  return (
    <Modal
      header={t("removeCost.title")}
      headerClassName={styles.header}
      close={cancel}
    >
      <div className={styles.main}>
        <div className={styles.group}>
          <p className={styles.text}>{t("removeCost.message")}</p>
        </div>
        <div className={styles.buttons}>
          <Button type="cancel" press={cancel}>
            {t("removeCost.cancel")}
          </Button>
          <Button
            type="delete"
            status={isRequestPending ? "pending" : "none"}
            press={() => removeCost(cost)}
          >
            {t("removeCost.confirm")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export { CostRemoval };
